import React from 'react';
import { Box, Container, Typography } from '@mui/material';

export default function TermsOfServicePage() {
  return (
    <Box
      sx={{ bgcolor: 'background.default', minHeight: '100vh', pt: 12, pb: 8 }}
    >
      <Container maxWidth="md">
        <Typography variant="h2" sx={{ fontWeight: 700, mb: 2 }}>
          Terms of Service
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 6 }}>
          Last updated: December 31, 2025
        </Typography>

        <Box
          sx={{
            '& h3': { fontWeight: 600, mt: 4, mb: 2 },
            '& p': { mb: 2, lineHeight: 1.8 },
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1">
            By accessing and using SimplyPayroll ("the Service"), you accept and
            agree to be bound by the terms and provisions of this agreement. If
            you do not agree to these terms, please do not use the Service.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 4 }}>
            2. Description of Service
          </Typography>
          <Typography variant="body1">
            SimplyPayroll provides contractor payroll tracking software that
            allows users to:
          </Typography>
          <Typography component="ul" variant="body1" sx={{ pl: 4 }}>
            <li>Track contractor hours and payments</li>
            <li>Calculate gross pay based on hourly rates or flat rates</li>
            <li>Generate 1099-MISC tax forms</li>
            <li>Store contractor information securely</li>
          </Typography>
          <Typography variant="body1">
            SimplyPayroll does NOT process actual payments or tax withholdings.
            Users are responsible for making payments to contractors and
            fulfilling all tax obligations.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 4 }}>
            3. User Accounts
          </Typography>
          <Typography variant="body1">
            You are responsible for maintaining the confidentiality of your
            account and password. You agree to accept responsibility for all
            activities that occur under your account.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 4 }}>
            4. Subscription and Billing
          </Typography>
          <Typography variant="body1">
            SimplyPayroll offers monthly and annual subscription plans.
            Subscriptions automatically renew unless cancelled before the
            renewal date. You will be charged the then-current subscription rate
            upon renewal.
          </Typography>
          <Typography variant="body1">
            We reserve the right to change subscription prices with 30 days'
            notice. Refunds are provided within 14 days of purchase for any
            reason.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 4 }}>
            5. User Responsibilities
          </Typography>
          <Typography variant="body1">You agree to:</Typography>
          <Typography component="ul" variant="body1" sx={{ pl: 4 }}>
            <li>Provide accurate information when using the Service</li>
            <li>Verify all generated 1099 forms for accuracy before filing</li>
            <li>Comply with all applicable tax laws and regulations</li>
            <li>Not use the Service for any illegal or unauthorized purpose</li>
            <li>
              Not attempt to gain unauthorized access to the Service or related
              systems
            </li>
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 4 }}>
            6. Limitation of Liability
          </Typography>
          <Typography variant="body1">
            SimplyPayroll is a tracking and record-keeping tool. The Service
            does not provide tax, legal, or accounting advice. You are solely
            responsible for:
          </Typography>
          <Typography component="ul" variant="body1" sx={{ pl: 4 }}>
            <li>
              Verifying the accuracy of all calculations and generated forms
            </li>
            <li>Ensuring compliance with federal, state, and local tax laws</li>
            <li>Filing all required tax forms with appropriate authorities</li>
            <li>Making actual payments to contractors</li>
          </Typography>
          <Typography variant="body1">
            SimplyPayroll shall not be liable for any penalties, interest, or
            damages resulting from inaccurate data entry, late filing, or
            non-compliance with tax regulations.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 4 }}>
            7. Data Security
          </Typography>
          <Typography variant="body1">
            We implement reasonable security measures to protect your data,
            including encryption of sensitive information (SSN, EIN, Tax IDs).
            However, no internet transmission is completely secure. You
            acknowledge that you provide information at your own risk.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 4 }}>
            8. Intellectual Property
          </Typography>
          <Typography variant="body1">
            The Service and its original content, features, and functionality
            are owned by SimplyPayroll and are protected by international
            copyright, trademark, and other intellectual property laws.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 4 }}>
            9. Termination
          </Typography>
          <Typography variant="body1">
            We may terminate or suspend your account immediately, without prior
            notice, for any breach of these Terms. You may cancel your
            subscription at any time from your account settings.
          </Typography>
          <Typography variant="body1">
            Upon termination, your right to use the Service will cease
            immediately. You will retain access to download your data for 30
            days after cancellation.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 4 }}>
            10. Changes to Terms
          </Typography>
          <Typography variant="body1">
            We reserve the right to modify these terms at any time. We will
            notify users of any material changes via email. Continued use of the
            Service after changes constitutes acceptance of the new terms.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 4 }}>
            11. Governing Law
          </Typography>
          <Typography variant="body1">
            These Terms shall be governed by and construed in accordance with
            the laws of the State of California, United States, without regard
            to its conflict of law provisions.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 4 }}>
            12. Contact Information
          </Typography>
          <Typography variant="body1">
            If you have any questions about these Terms, please contact us at:
          </Typography>
          <Typography variant="body1" sx={{ pl: 2 }}>
            Email: 4YourBusinessImage@gmail.com
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
